import { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Button, Form, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import backgroundImage from "../../assets/images/solarpower.jpg";
import Captcha from '../../component/Captcha';
import img2 from "../../assets/images/harnesssolar.png";
import icon1 from "../../assets/icons/High Efficency.png"
import icon2 from "../../assets/icons/Durability.png"
import icon3 from "../../assets/icons/Temp Coefficient.png"
import icon4 from "../../assets/icons/Low degradation.png"
import icon5 from "../../assets/icons/Reliable Warranty.png"
import icon6 from "../../assets/icons/Quality Testing.png"
import icon7 from "../../assets/icons/ALMM & BIS approved.png"
import "./KusumYojna.css";

import TestimonialSlider from "./TestimonialSlider";
import { Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { FaCheckCircle, FaEnvelope, FaWhatsapp } from "react-icons/fa"

const features = [
  {
    icon: <img src={icon1} alt="HIGH EFFICIENCY" className="feature-icon" />,
    title: "HIGH EFFICIENCY",
    description: "Achieve more than 22% (TOPCon) / 21% (Mono PERC) efficiency with our solar panels."
  },
  {
    icon: <img src={icon2} alt="DURABILITY" className="feature-icon" />,
    title: "DURABILITY",
    description: "Designed to withstand harsh environmental conditions, ensuring longevity and minimal maintenance."
  },
  {
    icon: <img src={icon3} alt="TEMPERATURE COEFFICIENT" className="feature-icon" />,
    title: "TEMPERATURE COEFFICIENT",
    description: "Low Temperature Coefficient of -0.29% / °C (TOPCon) and -0.39% / °C ensures good performance even in high temperatures."
  },
  {
    icon: <img src={icon4} alt="LOW DEGRADATION" className="feature-icon" />,
    title: "LOW DEGRADATION",
    description: "1st Year Degradation of 1% (TOPCon) / 2% (Mono PERC) and Annual Degradation of -0.4% (TOPCon) / 0.55% (Mono PERC) ensures high generation year-over-year."
  },
  {
    icon: <img src={icon5} alt="Reliable Warranty" className="feature-icon" />,
    title: "Reliable Warranty",
    description: "25 years warranty on Solar Panel Performance from an experienced company which has been in the industry for 27+ Years"
  },
  {
    icon: <img src={icon6} alt="Quality Testing" className="feature-icon" />,
    title: "Quality Testing",
    description: "Stringent testing performed across 70+ Parameters to ensure best quality panels / 0.55% (Mono PERC) ensures high generation year-over-year."
  },
  {
    icon: <img src={icon7} alt="ALMM/BIS Approved" className="feature-icon" />,
    title: "ALMM/BIS Approved",
    description: "Solar Panels in conformance with MNRE’s standards "
  }
];

const chunkArray = (array, size) => {
  const chunkedArr = [];
  for (let i = 0; i < array.length; i += size) {
    chunkedArr.push(array.slice(i, i + size));
  }
  return chunkedArr;
};

const KusumYojna = () => {
  const [captchaInput, setCaptchaInput] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [captchaValue, setCaptchaValue] = useState('');
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [chunkedFeatures, setChunkedFeatures] = useState(chunkArray(features, 4));
  const [loading, setLoading] = useState(false);
  const [showVideo, setShowVideo] = useState(false);


  const handleCaptchaChange = (value) => {
    setCaptchaInput(value);
  };
  const handleCaptchaReset = () => {
    setResetCaptcha(true);
  };

  const handleCheckboxChange = (event) => {
    const { checked, labels } = event.target;
    setSelectedOption(checked ? labels[0].innerText : null);
  };


  const formRef = useRef();

  const sectionStyle = {
    backgroundImage: `url(${backgroundImage})`,
    opacity: "0.9",
    backgroundBlendMode: 'multiply',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '300px',
    width: "100%",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const sendEmail = async (event) => {
    event.preventDefault();
    if (captchaInput === captchaValue) {
      alert('CAPTCHA Verified!');
      const formData = new FormData(formRef.current);
      let utm = localStorage.getItem('utm_data') || null;
      const data = {
        name: formData.get('name'),
        phone: formData.get('phone'),
        city: formData.get('city'),
        projectSize: formData.get('Project Size'),
        selectedOption: selectedOption,
        utm: utm
      };


      try {
        setLoading(true);
        const response = await fetch('https://gautamsolar.us/submit-pmkusum', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });


        if (response.ok) {
          console.log('Form submitted successfully');
          formRef.current.reset();
          localStorage.removeItem('utm_data');
        } else {
          console.error('Failed to submit form');
        }
        setLoading(false);
        setShowModal(true);
        handleCaptchaReset();
      } catch (error) {
        setLoading(false);
        console.error('Error submitting form:', error);
      }
    } else {
      alert('CAPTCHA Verification Failed! Please try again.');
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setChunkedFeatures(chunkArray(features, 1));
      } else {
        setChunkedFeatures(chunkArray(features, 4));
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  return (
    <>
      <Helmet>
        <title>PM-Kusum Yojna for farmers</title>
        <meta name="description" content="Empower your farm with Gautam Solar’s panels for PM‑KUSUM Yojna. With 60 MW of panels already installed and 300 MW in progress, these Mono PERC & TOPCon modules are optimized for Indian agricultural.  " />

        <meta name="keywords" content="PM-Kusum Yojna for farmers, Pradhan Mantri Kisan Urja Suraksha evam Utthaan Mahabhiyan, solar energy " />

        <link rel="canonical" href="https://gautamsolar.com/kusum/" />
      </Helmet>

      <h1 className="sr-only">Harness Solar Power with PM-KUSUM Yojana</h1>

      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-d29e141 elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default"
        data-id="d29e141"
        data-element_type="section"
        data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}"
        style={{ ...sectionStyle }}
      >
        <div className="elementor-background-overlay"></div>
        <Container className="elementor-container elementor-column-gap-no">
          <Row className="elementor-row">
            <Col className="elementor-column elementor-col-12 elementor-top-column elementor-element elementor-element-0a1c64f" data-id="0a1c64f" data-element_type="column">
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div
                    className="elementor-element elementor-element-b12b60d elementor-widget elementor-widget-modina_section_title"
                    data-id="b12b60d"
                    data-element_type="widget"
                    data-widget_type="modina_section_title.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="block-contents text-center">
                        {/* <div className="section-title"> */}
                        <h2 className="resText lh-1">
                          <span style={{ color: "black" }}>Enquiry For</span><br></br>
                          <span style={{ color: "white", backgroundColor: "#a20000", display: "inline-block", marginTop: "10px" }}>PM-Kusum Yojna</span>
                        </h2>
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="text-center my-5 border" style={{ width: '100%' }}>

        <div className="col-lg-10 col-md-12 mx-auto text-center py-5">
          <h2 className="TextRes" style={{ position: 'relative', color: 'black' }}>
            <span style={{ fontSize: "55px", position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', borderBottom: '2px solid #faab04', width: '50px' }}></span>
            Harness Solar Power  <span style={{ color: "#a20000" }}>
              With PM-KUSUM Yojana
              {" "}
            </span>
          </h2>
        </div>

        <div className=" border" style={{ width: '100%' }}>

          <div style={{ width: '100%', height: '70%' }}>
            <div
              onClick={() => setShowVideo(true)}
              className="position-relative "
              style={{
                width: '100%',
                overflow: 'hidden',
                aspectRatio: '16/9',
              }}
            >
              <video

                style={{
                  width: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.5s ease',
                }}
                loop
                autoPlay
                muted
                playsInline
                preload='auto'
                src="/pmkusumVideo.mp4"

              ></video>

              {/* Overlay */}
              <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ background: 'rgba(0,0,0,0.15)' }}
              ></div>
            </div>

          </div>


          <style jsx>{`
    .content-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      max-width: 800px;
      margin: 0 auto;
    }

    .image-container {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }

    .description {
      text-align: center;
      padding: 0 15px;
      margin-top: 0;
    }
             `}</style>
        </div>
      </section>

      {/* video */}
      <div className="py-5 fade-up border-top">
        <div style={{ width: '100%' }}>
          <h2 className="mb-3 TextRes px-2 text-uppercase text-center">
            Gautam Solar powered <span style={{ color: '#a20000' }}> PM KUSUM Plants </span>
          </h2>

          {/* Video Container */}
          <div
            className="position-relative "
            style={{
              width: '100%',
              overflow: 'hidden',
              aspectRatio: '16/9',
            }}
          >
            <video

              style={{
                width: '100%',
                objectFit: 'cover',
                transition: 'transform 0.5s ease',
              }}
              loop
              autoPlay
              muted
              playsInline
              preload='auto'
              src="/Kusum Final Rajasthan & MP.mp4"

            ></video>

            {/* Overlay */}
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{ background: 'rgba(0,0,0,0.15)' }}
            ></div>
          </div>
        </div>
      </div>

      <section className="my-4" style={{ width: '100%' }}>
        <div className=" custom-container" style={{ width: '100%' }}>
          <div className="p-4 border pm-card custom-card">
            <div className="py-4">
              <div className="col-lg-10 col-md-12 mx-auto text-center">
                <h2 className="mb-3 TextRes px-2 text-uppercase text-center">
                  Empowering PM-KUSUM with
                  {" "}
                  <span style={{ color: '#a20000' }}>
                    Reliable Solar Solutions
                  </span>
                </h2>
              </div>

              <p className="text-center " style={{ fontSize: 'clamp(1rem, 1.4vw, 1.25rem)' }}>

                Gautam Solar is proud to be a trusted partner in the PM-KUSUM scheme, playing a key role in supporting India's solar revolution.

                200 MW of supplies already completed under KUSUM across multiple locations
                300 MW of ongoing supplies currently in progress
                Panels engineered for superior power generation and long-term performance
                Fully automated manufacturing ensures consistent quality and timely dispatches
                Backed by a robust service and support network across multiple locations

                With proven reliability and scalable capacity, Gautam Solar modules are ideal for the KUSUM scheme.
              </p>
            </div>
          </div>
        </div>
        {/* slider */}
        <div style={{ marginTop: '2rem', overflowX: 'hidden' }}>
          <div className="carousel-wrapper px-4">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={24}

              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
            >
              {chunkedFeatures.flat().map((feature, idx) => (
                <SwiperSlide key={idx}>
                  <div
                    style={{
                      background: '#fff',
                      borderRadius: '12px',
                      padding: '1.5rem',
                      textAlign: 'center',
                      minHeight: '300px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                      height: '100%',
                    }}
                    className="border"
                  >
                    <div>{feature.icon}</div>
                    <h4 style={{ color: '#a20000', fontSize: 'clamp(1rem, 1.2vw, 1.25rem)', marginTop: '1rem' }}>
                      {feature.title}
                    </h4>
                    <hr style={{ margin: '1rem 0' }} />
                    <p style={{ fontSize: 'clamp(0.9rem, 1vw, 1rem)' }}>
                      {feature.description}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      <TestimonialSlider />


      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton style={{ backgroundColor: "#f8f9fa" }}>
          <Modal.Title style={{ fontWeight: "bold", color: "#a20000", display: "flex", alignItems: "center", gap: "10px" }}>
            <FaCheckCircle size={24} />
            Thank You!
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "20px", fontSize: "16px", color: "#333" }}>
          <p style={{ marginBottom: "12px" }}>
            Your form has been <strong>submitted successfully</strong>!
          </p>
          <p style={{ marginBottom: "16px" }}>
            <strong>Thank you for connecting with us.</strong><br />
            We’ll reach out to you soon.
          </p>

          <div style={{
            backgroundColor: "#f1f1f1",
            padding: "12px 16px",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaEnvelope style={{ color: "#a20000" }} />
              <a href="mailto:info@gautamsolar.com" style={{ color: "#a20000", textDecoration: "none" }}>
                info@gautamsolar.com
              </a>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FaWhatsapp style={{ color: "#a20000" }} />
              <a href="https://wa.me/9311797248" target="_blank" rel="noopener noreferrer" style={{ color: "#a20000", textDecoration: "none" }}>
                9311797248
              </a>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer style={{ backgroundColor: "#f8f9fa" }}>
          <Button style={{ backgroundColor: '#a20000' }} onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="bg-color my-5 ">
        <h2 className="text-center">Enquire Now</h2>
        <Form ref={formRef} onSubmit={sendEmail} className="border p-2 rounded">
          <Row className="mb-4">
            <Col xs={12} md={6} className="my-1">
              <Form.Control
                required
                type="text"
                placeholder="Name*"
                name="name"
                aria-label="Name"
              />
            </Col>
            <Col xs={12} md={6}>
              <Form.Control
                required
                type="text"
                placeholder="Mobile No*"
                name="phone"
                aria-label="Mobile Number"
              />
            </Col>
          </Row>
          <Row className="mb-4">

            <Col xs={12} md={6} className="my-1">
              <Form.Control
                required
                type="text"
                placeholder="City*"
                name="city"
                aria-label="City"
              />
            </Col>
            <Col xs={12} md={6}>
              <Form.Control
                required
                type="text"
                placeholder="Project Size*"
                name="Project Size"
                aria-label="Project Size"
              />
            </Col>
          </Row>
          <Row className="mb-4">

            <Col xs={12} md={6}>
              <Form.Check
                type="checkbox"
                id="scheme-checkbox"
                label="I have been selected for the PM-KUSUM scheme."
                name="scheme"
                aria-label="I have been selected for the PM-KUSUM scheme."
                checked={selectedOption === "I have been selected for the PM-KUSUM scheme."}
                onChange={handleCheckboxChange}
              />
            </Col>
            <Col xs={12} md={6}>
              <Form.Check
                type="checkbox"
                id="tenders-checkbox"
                label="I want to participate in future PM-KUSUM tenders."
                name="tenders"
                aria-label="I want to participate in future PM-KUSUM tenders."
                checked={selectedOption === "I want to participate in future PM-KUSUM tenders."}
                onChange={handleCheckboxChange}
              />
            </Col>
          </Row>
          <div className="text-center p-4">
            <Captcha
              captchaValue={captchaValue}
              setCaptchaValue={setCaptchaValue}
              handleCaptchaChange={handleCaptchaChange}
              resetCaptcha={resetCaptcha}
              setResetCaptcha={setResetCaptcha}
            />
            <Button

              style={{ backgroundColor: "#a20000", color: "#ffffff" }}
              type="submit"
              variant="danger"
              disabled={loading}
            >
              {loading ?
                <div className="spinner-border text-white" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                :
                'Submit'
              }
            </Button>
          </div>
        </Form>
      </div>

      {showVideo &&
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'black',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99999999999,
          }}
        >
          {/* Close Button */}
          <button
            onClick={() => setShowVideo(false)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'rgba(0,0,0,0.5)',
              color: 'white',
              border: 'none',
              fontSize: '24px',
              padding: '10px',
              borderRadius: '50%',
              cursor: 'pointer',
            }}
          >
            ✕
          </button>

          <video
            src="/pmkusumVideo.mp4"
            loop
            controls
            autoPlay
            width="80%"
            height="80%"
          />
        </div>
      }
    </>
  );
};

export default KusumYojna;
